import { useEffect } from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { MessageRuleTestRequest, MessageRule } from "../../../../models";

import { StringDetailedResponse } from "../../../../models/swagger/generated-submission-service";
import { MessageRulesService } from "../../../../services/ClientService";

export type MessageRuleTestModalProps = {
    show: boolean;
    attorneyId?: string;
    county?: string;
    filename?: string;
    claimAmount?: number;
    data?: MessageRule;
    onSubmit: () => void;
    onClose: () => void;
};

export default function MessageRuleTestModal({
    show,
    attorneyId,
    county,
    filename,
    claimAmount,
    onSubmit,
    onClose,
}: MessageRuleTestModalProps) {
    const [rule, setRule] = useState({
        attorneyID: attorneyId,
        county: county,
        filename: filename,
        claimAmount: claimAmount,
    } as MessageRuleTestRequest);

    const [data, setData] = useState("");

    useEffect(() => {
        setRule({
            attorneyID: attorneyId,
            county: county,
            filename: filename,
            claimAmount,
        });
    }, [show, attorneyId, county, filename, claimAmount]);

    const submitRule = () => {
        MessageRulesService.getRule({
            body: {
                ...rule,
            },
        }).then(
            (resp) => {
                //onSubmit();
                setData(JSON.stringify(resp.data));
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const closeWindow = () => {
        setData("");
        onClose();
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Message Rule Test
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row form-group m-2">
                    <div className="col-sm-6">
                        <label>Attorney ID</label>
                        <input
                            className="form-control"
                            id="messageRuleAttorneyID"
                            type="text"
                            defaultValue={rule.attorneyID}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    attorneyID: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-6">
                        <label>County</label>
                        <input
                            className="form-control"
                            id="messageRuleCounty"
                            type="text"
                            defaultValue={rule.county}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    county: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Filename</label>
                        <input
                            className="form-control"
                            id="messageRuleFilename"
                            type="text"
                            defaultValue={rule.filename}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    filename: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Amount</label>
                        <input
                            className="form-control"
                            id="messageRuleMaxAmount"
                            type="number"
                            defaultValue={0}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    claimAmount: parseFloat(
                                        event.currentTarget.value
                                    ),
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Result:</label>
                        <label>{data}</label>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-danger" onClick={closeWindow}>
                    Cancel
                </Button>
                <Button onClick={submitRule}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
}
